"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _sliderSecurity = require("@/utils/sliderSecurity");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SliderVerifyDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sliderImages: [require('@/assets/imgs/slider/slider-1.png'), require('@/assets/imgs/slider/slider-2.png'), require('@/assets/imgs/slider/slider-3.png')],
      refreshLocked: false,
      verifyLocked: false,
      refreshLockUntil: null,
      verifyLockUntil: null,
      lockTitle: '',
      activeLockType: null,
      skipRefreshCount: false,
      slideVerifyKey: 0,
      lockTimer: null
    };
  },
  computed: {
    interactionLocked: function interactionLocked() {
      return this.refreshLocked || this.verifyLocked;
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.handleDialogOpened();
      } else {
        this.clearLockTimers();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearLockTimers();
  },
  methods: {
    onDialogClose: function onDialogClose() {
      this.$emit('update:visible', false);
    },
    handleDialogOpened: function handleDialogOpened() {
      var _this = this;
      this.syncFromStorage();
      if (this.interactionLocked) {
        return;
      }
      var result = (0, _sliderSecurity.recordSliderGateOpen)();
      this.syncFromStorage();
      if (result.justLocked) {
        this.$message.warning(_sliderSecurity.LOCK_TITLES.refresh);
      }
      this.$nextTick(function () {
        if (!_this.interactionLocked) {
          _this.safeRefresh();
        }
      });
    },
    syncFromStorage: function syncFromStorage() {
      this.syncExpiredLocks();
      var state = (0, _sliderSecurity.normalizeSliderSecurityState)((0, _sliderSecurity.readSliderSecurityState)());
      this.refreshLocked = false;
      this.verifyLocked = false;
      this.refreshLockUntil = null;
      this.verifyLockUntil = null;
      this.activeLockType = null;
      this.clearLockTimers();
      var activeLock = (0, _sliderSecurity.getActiveLock)(state);
      if (activeLock) {
        this.applyLock(activeLock.type, activeLock.lockUntil, false);
        return;
      }
      this.lockTitle = '';
      (0, _sliderSecurity.writeSliderSecurityState)(state);
    },
    syncExpiredLocks: function syncExpiredLocks() {
      var state = (0, _sliderSecurity.normalizeSliderSecurityState)((0, _sliderSecurity.readSliderSecurityState)());
      var now = Date.now();
      var changed = false;
      if (state.refreshLockUntil && state.refreshLockUntil <= now) {
        (0, _sliderSecurity.unlockSliderInteraction)('refresh');
        changed = true;
      }
      if (state.verifyLockUntil && state.verifyLockUntil <= now) {
        (0, _sliderSecurity.unlockSliderInteraction)('verify');
        changed = true;
      }
      if (changed) {
        this.refreshLocked = false;
        this.verifyLocked = false;
        this.refreshLockUntil = null;
        this.verifyLockUntil = null;
        this.activeLockType = null;
        this.lockTitle = '';
      }
    },
    applyLock: function applyLock(type, lockUntil, showMessage) {
      if (type === 'refresh') {
        this.refreshLocked = true;
        this.refreshLockUntil = lockUntil;
      } else {
        this.verifyLocked = true;
        this.verifyLockUntil = lockUntil;
      }
      this.activeLockType = type;
      this.lockTitle = _sliderSecurity.LOCK_TITLES[type];
      (0, _sliderSecurity.markSliderRequired)();
      this.startLockTimer(type, lockUntil);
      if (showMessage) {
        this.$message.warning(this.lockTitle);
      }
    },
    startLockTimer: function startLockTimer(type, lockUntil) {
      var _this2 = this;
      this.clearLockTimers();
      var checkExpiry = function checkExpiry() {
        if (Date.now() >= lockUntil) {
          _this2.unlockInteraction(type);
        }
      };
      checkExpiry();
      this.lockTimer = setInterval(checkExpiry, 1000);
    },
    safeRefresh: function safeRefresh() {
      if (this.interactionLocked) {
        return;
      }
      this.skipRefreshCount = true;
      if (this.$refs.slideBlock) {
        this.$refs.slideBlock.refresh();
      }
    },
    onRefresh: function onRefresh() {
      if (this.interactionLocked) {
        return;
      }
      if (this.skipRefreshCount) {
        this.skipRefreshCount = false;
        return;
      }
      var result = (0, _sliderSecurity.recordSliderRefreshClick)();
      this.syncFromStorage();
      if (result.justLocked) {
        this.$message.warning(_sliderSecurity.LOCK_TITLES.refresh);
      }
    },
    recordVerifyFailure: function recordVerifyFailure() {
      if (this.interactionLocked) {
        return;
      }
      var result = (0, _sliderSecurity.recordSliderVerifyFailure)();
      this.syncFromStorage();
      if (result.justLocked) {
        this.$message.warning(_sliderSecurity.LOCK_TITLES.verify);
      }
    },
    unlockInteraction: function unlockInteraction(type) {
      var _this3 = this;
      (0, _sliderSecurity.unlockSliderInteraction)(type);
      if (type === 'refresh') {
        this.refreshLocked = false;
        this.refreshLockUntil = null;
      } else {
        this.verifyLocked = false;
        this.verifyLockUntil = null;
      }
      if (this.activeLockType === type) {
        this.activeLockType = null;
        this.lockTitle = '';
        this.clearLockTimers();
      }
      if (!this.interactionLocked && this.visible) {
        this.slideVerifyKey += 1;
        this.$nextTick(function () {
          _this3.safeRefresh();
        });
      }
    },
    clearLockTimers: function clearLockTimers() {
      if (this.lockTimer) {
        clearInterval(this.lockTimer);
        this.lockTimer = null;
      }
    },
    onSuccess: function onSuccess() {
      var _this4 = this;
      if (this.interactionLocked) {
        return;
      }
      (0, _user.sliderPassApi)().then(function () {
        (0, _sliderSecurity.clearSliderVerifyFailures)();
        (0, _sliderSecurity.clearSliderRequired)();
        _this4.$emit('update:visible', false);
        _this4.$emit('passed');
      }).catch(function () {
        _this4.safeRefresh();
      });
    },
    onFail: function onFail() {
      if (this.interactionLocked) {
        return;
      }
      this.recordVerifyFailure();
      if (!this.verifyLocked) {
        this.$message.warning('验证失败，请重试');
      }
    },
    onAgain: function onAgain() {
      if (this.interactionLocked) {
        return;
      }
      this.recordVerifyFailure();
      if (!this.verifyLocked) {
        this.$message.warning('检测到异常操作，请重试');
        this.safeRefresh();
      }
    }
  }
};